























import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import _ from "lodash";

import moment from "moment";

import MyCommon from "@/mixins/common";

@Component
export default class extends Mixins(MyCommon) {
  @Prop() stadiumId!: number;
  @Prop() online_read_time!: string;
  @Prop() updateOnlineReadTime!: Function;

  online_read_time_status = false;

  async mounted() {
    if (!this.online_read_time || this.online_read_time.indexOf("0001-01-01") >= 0) {
      this.online_read_time_status = true;
    } else {
      this.online_read_time_status = false;
    }
  }

  // 激活taisam机器人
  changeOnlineReadTime(val: boolean) {
    this.showTsConfirm({
      title: "确认信息",
      content: `确定要${val ? "激活" : "跳过"}Taisam机器人`,
      onOk: () => {

        this.$store.dispatch("stadium/activeOnlineReadTime", {
          stadium_id: this.stadiumId,
          status: val ? 1 : 0,
        });
        this.$message.success("操作成功");
        this.online_read_time_status = val;
        this.updateOnlineReadTime(val ? "" : moment().format("YYYY-MM-DD HH:mm:ss"));
      },
      onCancel: () => {
        // this.phone_status = val ? false : val;
      },
    });
  }
}
